import { FC, useMemo } from "react"
import { VideoJS } from "components"

export const AssetVideoLink: FC<any> = ({ asset }) => {
  const { pack_id, type, data: { url, content_type, streamable } } = asset;

  const videoJsOptions = useMemo(() => {
    let sources = [{
      src: url,
      type: content_type,
      withCredentials: true
    }];

    return {
      controls: true,
      responsive: true,
      fluid: true,
      sources
    }
  }, [ pack_id, url, type, content_type, streamable ]);

  return (
    <VideoJS options={videoJsOptions}  />
  );
};
